require('./style.less');

var Marionette = require('marionette'),
	Spinner = require('../spinView');


//todo pass doc info (or other info)

module.exports = Marionette.ItemView.extend({
	className: 'FV-reset-wr',
	template: require('./template.hbs'),
	ui: {
		spinHolder: '[data-spin-holder]' //todo: could be behavior
	},
	onRender: function() {
		this.unwrap();
		this.spinner = new Spinner({
			color: '#FFF'
		});
		this.ui.spinHolder.append( this.spinner.render().el );
	},
	onBeforeDestroy: function() {
		this.spinner.destroy();
	}
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/common/resetPlaceholder/resetPlaceholder.js
 ** module id = 557
 ** module chunks = 0
 **/